import { displayDate } from '../../../../../../../../../utils/globals/date'
import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { InputTableLayoutData } from '../../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { SellInvoiceRefundLogModelType } from '@teinor/erp/types/company/order/sell/sellInvoiceRefund/sellInvoiceRefundLog'
import { Fragment } from 'react'
import OrderStatusBar from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderStatusBar'
import { getOrderStatusBarType } from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderStatusBar/functions'
import OrderStatusBarDropDown from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderStatusBarDropDown'
import { sellInvoiceRefundStatusInversed } from '@teinor/erp/types/company/order/sell/sellInvoiceRefund'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons'


interface SellInvoiceRefundStatusBarProps extends InvoiceRefundCreateStatusBarProps { 
}

const SellInvoiceRefundStatusBar: React.FC<SellInvoiceRefundStatusBarProps> = ({ completeData}) => {
    const { statuses } = useCreateStatusBar({ completeData })
    return (
        <OrderStatusBar statuses={statuses} currentOrderStatus={completeData?.header.status} getOrderStatusBarType={getOrderStatusBarType} />
    )
}

export interface InvoiceRefundCreateStatusBarProps {
    completeData: InputTableLayoutData | null
}

const useCreateStatusBar = ({ completeData }: InvoiceRefundCreateStatusBarProps) => {
    const { t } = useTwinTranslation()
    const OrderLogs = completeData?.header?.OrderLogs
    let statuses: TwinDictionary[] = []
    const dictOrderLogs: TwinDictionary = {}
    for (const log of OrderLogs) {
        if (!dictOrderLogs[log.logType]) {
            dictOrderLogs[log.logType] = [log]
        } else {
            dictOrderLogs[log.logType] = [...dictOrderLogs[log.logType], log]
        }
    }
    statuses.push({
        id: -1,
        name: t('sellInvoice', 'Factura'),
        logType: 0,
        color: 'bg-green-43',
        icon: faCheckCircle,
        className: 'text-green-43',
        renderMessage: dictOrderLogs[0]?.length ? <RenderLogMessage logs={dictOrderLogs[0] || []} /> : null
    })
    statuses.push({
        id: 2,
        name: t('refunded', 'Devuelto'),
        logType: 2,
        color: 'bg-green-43',
        icon: faCheckCircle,
        className: 'text-green-43',
        renderMessage: dictOrderLogs[2]?.length ? <RenderLogMessage logs={dictOrderLogs[2] || []} /> : null
    })
    

    return { statuses }
}

interface RenderLogMessageProps {
    logs: SellInvoiceRefundLogModelType[]
}

const RenderLogMessage: React.FC<RenderLogMessageProps> = ({ logs }) => {
    const { tVars } = useTwinTranslation()
    const renderMessage: JSX.Element[] = []
    for (const log of logs) {
        const myExtraData = log?.extraData ? JSON.parse(log?.extraData) : null
        const options = { employeeTrigger: log.EmployeeTrigger?.fullname_short || '', date: displayDate(new Date(log.createdAt)), full_assigned_number: myExtraData?.full_assigned_number || null, 'interpolation': { 'escapeValue': false }}
        const dictSellInvoiceRefundLogsMessages: TwinDictionary = {
            0: tVars('createdInvoiceRefundBySellInvoiceDateLogMessage', '{{employeeTrigger}} creó la devolución el {{date}} a partir de la factura {{full_assigned_number}}', options),
            1: '',
            2: tVars('finishInvoiceLogMessage', '{{employeeTrigger}} marcó la devolución como finalizada el {{date}}', options),
        }
        if (dictSellInvoiceRefundLogsMessages[log.logType]) {
            renderMessage.push(<div className='my-5' key={log.id} > {dictSellInvoiceRefundLogsMessages[log.logType]} </div>)
        }
    }
    if (!renderMessage.length) {
        return null
    }
    return (<Fragment>{renderMessage}</Fragment>)
}

export const SellInvoiceRefundStatusBarNew: React.FC<SellInvoiceRefundStatusBarProps> = ({ completeData }) => {
    const { statuses } = useCreateStatusBar({ completeData })
    const sellInvoiceRefundStatus = completeData?.header?.status
    return (
        <OrderStatusBarDropDown statuses={statuses} currentOrderStatus={sellInvoiceRefundStatus} getOrderStatusBarType={getOrderStatusBarType} isAccepted={sellInvoiceRefundStatus === sellInvoiceRefundStatusInversed['accepted']} />
    )
}

export default SellInvoiceRefundStatusBar